import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import BranchManagementView from './views/BranchManagementView';

export const essBranchManagementRoutes: RouteObject[] = [
    {
        path: '/admin/loan-settings/ess-branches',
        element: <BranchManagementView />,
        errorElement: <ErrorBoundary />,
    },
];
